module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/login-bg@2x-023628e376ffc929ff500ee4e005006b.jpg";